import { useEffect } from 'react';
import { Vector3, Camera } from 'three';
import { MapControls } from 'drei';

const MIN_PAN = new Vector3(-350, -2, -80);
const MAX_PAN = new Vector3(0, 2, 80);
const _tempVector = new Vector3();

/**
 * useLimitMovement hook add pan limits to an MapControls
 * 
 * @param controls {MapControls} The MapControls instance
 * @param camera  {Camera} The camera used in MapControls
 */
const useLimitMovement = (controls: MapControls | undefined, camera: Camera) => {
    useEffect(() => {
        const limitControlsMovementListener = () => {
            // If target available, clamp it to our Min/Max pan
            if (controls && controls.target) {
                _tempVector.copy(controls.target as Vector3);
                const currentTarget = controls.target as Vector3;
                currentTarget.clamp(MIN_PAN, MAX_PAN);
                _tempVector.sub(controls.target as Vector3);
                camera.position.sub(_tempVector);
            }
        };

        // Add event listener on each controls' change
        if (controls && controls.addEventListener) {
            controls.addEventListener('change', limitControlsMovementListener);
        }

    }, [controls, camera]);
};

export default useLimitMovement;
